import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { Col, Button, Row, Container, Card, Form, InputGroup, Table, Pagination, Badge } from 'react-bootstrap';
import { Page } from "../../dto/page/Page";
import SearchIcon from '@mui/icons-material/Search';
import { ShipmentSearch } from "../../dto/shipment/ShipmentSearch";
import { ShipmentEntity } from "../../dto/shipment/ShipmentEntity";
import { ShipmentListEntity } from "../../dto/shipment/ShipmentListEntity";
import { onShipmentSearch } from "../../controller/ShipmentController";
import { splitDate } from "../../app/Utils";
import { ShipmentEditDrawer } from "../../component/ShipmentEditDrawer";
import { getDeliveryPaymentStatusBadge, getDeliveryStatusBadge, getYesNo } from "../../app/AppConst";

const ShipmentList = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!AuthUtility.isUserLoggedIn()) {
            navigate("/login");
            window.location.reload();
        }
    }, [])

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedShipment, setSelectedShipment] = useState<ShipmentEntity | null>(null);

    const openDrawer = (shipment: ShipmentEntity) => {
        setSelectedShipment(shipment);
        setDrawerOpen(true);
    }

    const [search, setSearch] = useState<ShipmentSearch>({
        limit: 10
    });
    const [shipments, setShipments] = useState<ShipmentListEntity>({
        data: []
    });

    // ---- Search submit
    const searchSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        load(0); // reset to first page on new search
    };

    // ---- Pagination click
    const changePage = (page: number) => {
        if (!shipments.page) return;
        if (page < 0 || page >= shipments.page.totalPages) return;
        load(page);
    };

    const load = async (page: number = 0) => {
        const params: ShipmentSearch = {
            ...search,
            offset: page
        };

        const response = await onShipmentSearch(params);

        if (response.status !== 0) {
            toast.error("Shipment search unexpected error.");
            return;
        }

        const pageable = response.data;

        const pageInfo: Page = {
            limit: search.limit,
            totalElements: pageable.totalElements,
            totalPages: pageable.totalPages,
            offset: page
        };

        const beans: Array<ShipmentEntity> = pageable.beans;

        setShipments({
            page: pageInfo,
            data: beans
        });

        setSearch(prev => ({ ...prev, offset: page }));
    };

    return (
        <Container fluid>
            <div><Toaster position="top-right" reverseOrder={false}/></div>
            <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Хүргэлт</h3>
            <Row className="d-flex justify-content-center align-items-center mb-3">
                <Col md={12} lg={12} xs={12}>
                    <Card>
                        <Card.Header>
                            <Form onSubmit={searchSubmit}>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="status">
                                            <Form.Label>Статус</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Select 
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    if (value !== "") {
                                                        setSearch({
                                                            ...search,
                                                            status: event.target.value
                                                        })
                                                    } else {
                                                        const { status, ...rest } = search;
                                                        setSearch(rest);
                                                    }
                                                }}>
                                                    <option value=""></option>
                                                    <option value="CREATED">CREATED</option>
                                                    <option value="AWAITING_SHIPPING_PAYMENT">AWAITING_SHIPPING_PAYMENT</option>
                                                    <option value="READY_FOR_PICKUP">READY_FOR_PICKUP</option>
                                                    <option value="ASSIGNED_TO_DRIVER">ASSIGNED_TO_DRIVER</option>
                                                    <option value="PICKED_UP">PICKED_UP</option>
                                                    <option value="DELIVERED">DELIVERED</option>
                                                    <option value="SHIPPED">SHIPPED</option>
                                                    <option value="DELIVERY_CONFIRMED">DELIVERY_CONFIRMED</option>
                                                    <option value="FAILED">FAILED</option>
                                                    <option value="CANCELLED">CANCELLED</option>
                                                    <option value="AWAITING_EXTRA_SHIPPING_PAYMENT">AWAITING_EXTRA_SHIPPING_PAYMENT</option>
                                                </Form.Select>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="offSet">
                                            <Form.Label>Жолоочийн дугаар</Form.Label>
                                            <Form.Control size="sm" type="text" 
                                            onChange = {(event) => {
                                                const value = event.target.value;
                                                if (value !== "") {
                                                    setSearch({
                                                        ...search,
                                                        driverPhoneNo: event.target.value
                                                    })
                                                } else {
                                                    const { driverPhoneNo, ...rest } = search;
                                                    setSearch(rest);
                                                }
                                            }}/>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="offSet">
                                            <Form.Label>Багцлах</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Select size="sm"
                                                    onChange={(event) => setSearch({
                                                        ...search,
                                                        limit: parseInt(event.target.value)
                                                    })}>
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="0">Бүгд</option>
                                                </Form.Select>
                                                <Button variant="primary" size="sm" type="submit">
                                                    <SearchIcon fontSize="small"/>
                                                </Button>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive">
                                <Table hover>
                                    <thead>
                                        <tr>
                                            <th>Shipment ID</th>
                                            <th>Auction ID</th>
                                            <th>Product</th>
                                            <th>Seller</th>
                                            <th>Buyer</th>
                                            <th>Pickup address</th>
                                            <th>Delivery address</th>
                                            <th>Weight</th>
                                            <th>Quote</th>
                                            <th>Payment status</th>
                                            <th>Paid when</th>
                                            <th>Status</th>
                                            <th>Driver</th>
                                            <th>Vehicle No</th>
                                            <th>Picked up at</th>
                                            <th>Delivered at</th>
                                            <th>Confirmed at</th>
                                            <th>Created at</th>
                                            <th>Updated at</th>
                                            <th>Paid amount</th>
                                            <th>Extra payment due</th>
                                            <th>Extra paid at</th>
                                            <th>Finalized</th>
                                            {/* <th><InfoIcon /></th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {shipments.data.length === 0 && (
                                            <tr>
                                                <td className="text-muted">
                                                    Илэрц олдсонгүй
                                                </td>
                                            </tr>
                                        )}
                                        {
                                            shipments.data.map((data, idx) => {
                                                return (
                                                    <tr key={idx}>
                                                        <td style={{ cursor: "pointer", color: "#1976d2", fontWeight: 500 }} onClick={() => openDrawer(data)}>{data.id}</td>
                                                        <td><a href={`/listing/${data.listingId}`} target="_blank">{data.listingId}</a></td>
                                                        <td>ID: <a href={`/product/${data.productId}`} target="_blank">{data.productId}, </a>{data.productName}</td>
                                                        <td>{data.sellerNickname}</td>
                                                        <td>{data.buyerNickname}</td>
                                                        <td>{data.sellerFullAddress}</td>
                                                        <td>{data.buyerFullAddress}</td>
                                                        <td>{data.weightGrams}</td>
                                                        <td>{data.quoteAmount}</td>
                                                        <td><Badge bg={getDeliveryPaymentStatusBadge(data.shippingPaymentStatus)}>{data.shippingPaymentStatus}</Badge></td>
                                                        <td>{(splitDate(data.shippingPaidAt!))?.date} {(splitDate(data.shippingPaidAt!))?.time}</td>
                                                        <td>
                                                            {(() => {
                                                                const color = getDeliveryStatusBadge(data.status);
                                                                return (
                                                                    <Badge bg={color} className={color === "light" ? "text-dark" : ""}>
                                                                        {data.status}
                                                                    </Badge>
                                                                );
                                                            })()}
                                                        </td>
                                                        <td>{data.driverPhoneNo}</td>
                                                        <td>{data.vehicleNo}</td>
                                                        <td>{(splitDate(data.pickedUpAt!))?.date} {(splitDate(data.pickedUpAt!))?.time}</td>
                                                        <td>{(splitDate(data.deliveredAt!))?.date} {(splitDate(data.deliveredAt!))?.time}</td>
                                                        <td>{(splitDate(data.confirmedAt!))?.date} {(splitDate(data.confirmedAt!))?.time}</td>
                                                        <td>{(splitDate(data.createdAt!))?.date} {(splitDate(data.createdAt!))?.time}</td>
                                                        <td>{(splitDate(data.updatedAt!))?.date} {(splitDate(data.updatedAt!))?.time}</td>
                                                        <td>{data.shippingPaidAmount}</td>
                                                        <td>{data.extraShippingDueAmount}</td>
                                                        <td>{(splitDate(data.extraShippingPaidAt!))?.date} {(splitDate(data.extraShippingPaidAt!))?.time}</td>
                                                        <td><Badge bg={getYesNo(data.shippingPriceFinalized)}>{data.shippingPriceFinalized ? "YES" : "NO"}</Badge></td>
                                                        {/* <td><a href={`/shipment/${data.id}`}><InfoIcon /></a></td> */}
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>  
            </Row>
            <Row>
                {shipments.page && shipments.page.totalPages > 1 && (() => {
                    const page = shipments.page;   // now TypeScript knows it's NOT undefined

                    return (
                        <Row>
                            <Col className="d-flex justify-content-start mt-3">
                                <Pagination>
                                    <Pagination.First
                                        disabled={page.offset === 0}
                                        onClick={() => changePage(0)}
                                    />

                                    <Pagination.Prev
                                        disabled={page.offset === 0}
                                        onClick={() => changePage(page.offset - 1)}
                                    />

                                    {Array.from({ length: page.totalPages })
                                        .slice(
                                            Math.max(page.offset - 2, 0),
                                            Math.min(page.offset + 3, page.totalPages)
                                        )
                                        .map((_, idx) => {
                                            const pageNumber =
                                                Math.max(page.offset - 2, 0) + idx;

                                            return (
                                                <Pagination.Item
                                                    key={pageNumber}
                                                    active={pageNumber === page.offset}
                                                    onClick={() => changePage(pageNumber)}
                                                >
                                                    {pageNumber + 1}
                                                </Pagination.Item>
                                            );
                                        })}

                                    <Pagination.Next
                                        disabled={page.offset + 1 >= page.totalPages}
                                        onClick={() => changePage(page.offset + 1)}
                                    />

                                    <Pagination.Last
                                        disabled={page.offset + 1 >= page.totalPages}
                                        onClick={() => changePage(page.totalPages - 1)}
                                    />
                                </Pagination>
                            </Col>
                        </Row>
                    );
                })()}
            </Row>
            <ShipmentEditDrawer open={drawerOpen} shipment={selectedShipment} onClose={() => setDrawerOpen(false)} />
        </Container>
    )
}

export default ShipmentList;